export default {
  "dialogBackground": "_dialogBackground_lbjzb_1",
  "dialog": "_dialog_lbjzb_1",
  "header": "_header_lbjzb_19",
  "closeButton": "_closeButton_lbjzb_29"
};import "ni:sha-256;LZS5xmF_7dSgdVU_PqMrKo-LPOmhJdFq07yiHTu-bbk";